import React, { Component } from 'react';
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL, ADMIN, SUPER_ADMIN } from 'assets/constants/Constants';
import { EDIT_ICON, TRASH_ICON, KEY_ICON } from 'assets/constants/Icons';
import Spinner from 'components/Spinner';
import ShowToast from 'components/ShowToast';
import MaterialTable from 'material-table';
import { hasPermission } from 'components/Permission';
import { getUserList, getRoleListCall, deleteUserCall } from 'lib/axiosUtils';
import { ThemeProvider } from '@mui/styles';
import { createTheme, Divider } from '@mui/material';
import ResetPasswordComponent from 'components/ResetPasswordComponent';
import { UpdateUserCall } from 'lib/axiosUtils';
import './user-style.css';
import AuditReport from 'components/ProjectTracking/AuditReport';
import { CALENDER_ICON, AddCircleIcon } from 'assets/constants/Icons';
import moment from 'moment/moment';
import { PersonAdd } from '@material-ui/icons';

export class UserPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            isUsernamePresent: false,
            input: {
                userFirstName: '',
                userLastName: '',
                userEmailId: '',
                userPassword: '',
                userRole: '',
                openResetPasswordModal: false,
            },
            buttonText: 'Add User',
            userList: [],
            roleList: [],
            mytheme: createTheme({}),
            switchChecked: false,
        };
    }

    async componentDidMount() {
        try {
            const userData = await getUserList({}, {});
            const roleData = await getRoleListCall({}, {});
            this.setState({
                userList: userData.data.result,
                roleList: roleData.data.result,
                isLoading: false,
            });
        } catch (error) {
            console.log('Error occurred while fetching data', error);
        }
    }

    resetPasswordHandler = (rowData) => {
        this.setState(
            {
                userData: rowData,
            },
            () => {
                this.setState({
                    openResetPasswordModal: true,
                });
            }
        );
    };

    addEditUserHandler = (item) => {
        if (item) {
            const rowItem = {
                _id: item.userId,
                first_name: item.firstName,
                last_name: item.lastName,
                email_id: item.emailId,
                phone_number: item.phoneNumber,
                username: item.username,
                password: item.password,
                role: item.roleId,
                select_profile: item.selectProfile,
                company_id: item.selectedEmployer,
                employer_id: item.employerUnit,
                partner_id: item.selectedTrainingPartner,
            };
            if (item.userRole === ADMIN || item.userRole === SUPER_ADMIN) {
                this.props.history.push({
                    pathname: '/create-user-page',
                    state: { ...rowItem, isFromProfile: false },
                });
            } else {
                this.props.history.push({
                    pathname: '/create-user-page',
                    state: { ...rowItem, isFromProfile: false },
                });
            }
        } else {
            this.props.history.push({
                pathname: '/create-user-page',
                state: null,
            });
        }
    };

    handleDeleteUser = async (item) => {
        if (window.confirm('Are you sure you want to delete this user?')) {
            this.setState({ isLoading: true });
            let deleteResponse = await deleteUserCall({}, {}, item);
            if (deleteResponse.statusCode === 200) {
                let fetchResponse = await getUserList({}, {});
                this.setState({
                    userList: fetchResponse.data.result,
                    isLoading: false,
                });
                ShowToast('User deleted successfully', TYPE_SUCCESS, INTERVAL, this.props, '');
            } else {
                ShowToast(
                    'Something went wrong. Please delete again after sometime!',
                    TYPE_FAIL,
                    INTERVAL,
                    this.props,
                    ''
                );
            }
        }
    };

    handleDelete = async (item) => {
        if (item.userRole === ADMIN || item.userRole === SUPER_ADMIN) {
            // hasPermission("user","admin_profile") ? (
            this.handleDeleteUser(item.userId);
            // ):(
            //     ShowToast('You dont have permission.', TYPE_FAIL, INTERVAL, this.props, "")
            // )
        } else {
            this.handleDeleteUser(item.userId);
        }
    };

    cancelHandle = () => {
        if (this.state.openResetPasswordModal === true) {
            this.setState({
                openResetPasswordModal: false,
            });
        }
    };

    renderRole = (item) => {
        let roleNameArray = [];
        this.state.roleList.forEach((roleItem) => {
            if (roleItem._id === item) {
                roleNameArray.push(roleItem.user_role);
            }
        });
        return roleNameArray.join(', ');
    };

    renderUserRole = (item) => {
        let roleNameArray = [];
        this.state.roleList.forEach((roleItem) => {
            if (roleItem.user_role === item) {
                roleNameArray.push(roleItem._id);
            }
        });
        return roleNameArray.join(', ');
    };

    handleToggle = async (userId, currentFlag) => {
        if (
            window.confirm(
                `Are you sure you want to ${
                    currentFlag ? 'Disable' : 'Enable'
                } Audit for this user?`
            )
        ) {
            this.setState({ isLoading: true });

            const requestData = {
                auditflag: !currentFlag,
            };

            const userResponse = await UpdateUserCall({}, requestData, userId);
            if (userResponse.statusCode === 200) {
                let fetchResponse = await getUserList({}, {});
                this.setState({
                    userList: fetchResponse.data.result,
                    isLoading: false,
                });
                ShowToast(
                    `Audit ${currentFlag ? 'Disabled' : 'Enabled'}`,
                    TYPE_SUCCESS,
                    INTERVAL,
                    this.props,
                    ''
                );
            } else {
                ShowToast(
                    'Something went wrong, please try again',
                    TYPE_FAIL,
                    INTERVAL,
                    this.props,
                    ''
                );
            }
        }
    };

    render() {
        if (this.state.isLoading) {
            return <Spinner />;
        } else {
            return (
                <>
                    <div className="main-content user-page-outer-wrapper">
                        <div className="pagetitle row" style={{ color: 'black', paddingTop: 15, marginTop: "-25px" }}>
                            <div className="col-md-10 sm_device">
                                <PersonAdd sx={{ fontSize: 20 }} /> 
                                <span style={{ marginLeft: '7px', marginRight: '10px' }}>User Master</span>
                                <AddCircleIcon 
                                    onClick={() => this.addEditUserHandler(null)}
                                    style={{
                                        cursor: 'pointer',
                                        color: '#1976d2',
                                        fontSize: '30px !important',
                                    }}
                                    titleAccess="Add User"
                                />
                            </div>
                            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}>
                                <i className={`${CALENDER_ICON}`}></i> {moment().format('DD MMM YYYY')}
                            </div>
                        </div>
                        <Divider sx={{ mb: 2, mt: 2 }} />
                        <div className="list-wrapper">
                           
                            {/* {hasPermission('user', 'create') && (
                                <div className="user-button-view">
                                    {
                                        <>
                                            <button
                                                className="brand-button"
                                                onClick={() => this.addEditUserHandler(null)}
                                            >
                                                {this.state.buttonText}
                                            </button>
                                        </>
                                    }
                                </div>
                            )} */}

                            <div
                                className="mt-4 border list-table-div site-table"
                                style={{ marginBottom: 50 }}
                            >
                                {this.state.userList.length > 0 ? (
                                    <ThemeProvider theme={this.state.mytheme}>
                                        <MaterialTable
                                            columns={[
                                                {
                                                    title: 'Username',
                                                    field: 'username',
                                                    cellStyle: {
                                                        cellWidth: '12%',
                                                        textTransform: 'none',
                                                    },
                                                },
                                                {
                                                    title: 'User',
                                                    field: 'user',
                                                    cellStyle: {
                                                        cellWidth: '18%',
                                                        fontWeight: 'bolder',
                                                    },
                                                },
                                                {
                                                    title: 'Email Id',
                                                    field: 'emailId',
                                                    cellStyle: {
                                                        cellWidth: '20%',
                                                        textTransform: 'none',
                                                    },
                                                    sorting: false,
                                                },
                                                {
                                                    title: 'Phone Number',
                                                    field: 'phoneNumber',
                                                    cellStyle: {
                                                        cellWidth: '12%',
                                                    },
                                                    sorting: false,
                                                },
                                                {
                                                    title: 'Role',
                                                    field: 'userRole',
                                                    cellStyle: {
                                                        cellWidth: '14%',
                                                        textTransform: 'capitalize',
                                                    },
                                                },
                                                // hasPermission("user", "audit") && (
                                                //     {
                                                //         title: "Audit",
                                                //         field: "audit",
                                                //         sorting: false,
                                                //         filtering: false,
                                                //         render: rowData => (
                                                //             <>
                                                //                 <label class="toggle-switch">
                                                //                     <input type="checkbox" checked={rowData.isAudit} onChange={() => this.handleToggle(rowData.userId, rowData.isAudit)} />
                                                //                     <span class="slider"></span>
                                                //                 </label>
                                                //                 <AuditReport userId={rowData.userId} isFromTracking={false} />
                                                //             </>
                                                //         ),
                                                //     }
                                                // )
                                            ].filter(Boolean)}
                                            data={this.state.userList.map((item, index) => {
                                                return {
                                                    user: `${item.first_name} ${item.last_name}`,
                                                    firstName: item.first_name,
                                                    lastName: item.last_name,
                                                    emailId: item.email_id,
                                                    phoneNumber: item.phone_number,
                                                    username: item.username,
                                                    userRole: this.renderRole(item.role),
                                                    password: item.password,
                                                    confirmPassword: item.password,
                                                    userId: item._id,
                                                    roleId: item.role,
                                                    selectProfile: item.select_profile,
                                                    selectedEmployer: item.company_id,
                                                    employerUnit: item.employer_id,
                                                    selectedTrainingPartner: item.partner_id,
                                                    isAudit: item.audit_enable,
                                                };
                                            })}
                                            actions={[
                                                hasPermission('user', 'update') && {
                                                    icon: () => (
                                                        <i
                                                            className={`${KEY_ICON}`}
                                                            title="Reset Password"
                                                        ></i>
                                                    ),
                                                    onClick: (event, rowData) =>
                                                        this.resetPasswordHandler(rowData),
                                                },
                                                hasPermission('user', 'update') && {
                                                    icon: () => (
                                                        <i
                                                            className={`${EDIT_ICON}`}
                                                            title="Edit User"
                                                        ></i>
                                                    ),
                                                    onClick: (event, rowData) =>
                                                        this.addEditUserHandler(rowData),
                                                },
                                                hasPermission('user', 'delete') && {
                                                    icon: () => (
                                                        <i
                                                            className={`${TRASH_ICON}`}
                                                            title="Delete User"
                                                        ></i>
                                                    ),
                                                    onClick: (event, rowData) =>
                                                        this.handleDelete(rowData),
                                                },
                                            ].filter(Boolean)}
                                            options={{
                                                actionsColumnIndex: -1,
                                                headerStyle: {
                                                    color: '#2d3d42',
                                                    fontWeight: 'bolder',
                                                    fontSize: 14,
                                                },
                                                filtering: true,
                                                sorting: true,
                                                columnsButton: true,
                                                exportButton: true,
                                                exportFileName: 'User Data',
                                                cellStyle: {
                                                    color: '#2d3d42',
                                                    fontSize: 12
                                                }
                                            }}
                                        />
                                    </ThemeProvider>
                                ) : (
                                    <div className="text-center pt-2">
                                        <label>User records not found!</label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {this.state.openResetPasswordModal && (
                        <ResetPasswordComponent
                            modelOpen={this.state.openResetPasswordModal}
                            closeModel={this.cancelHandle}
                            userData={this.state.userData}
                        />
                    )}
                </>
            );
            // }
        }
    }
}

export default UserPage;
